import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowErrorMessageWithActionButtonInteractor {
  private notificationService: INotificationService;

  constructor({ notificationService }) {
    this.notificationService = notificationService;
  }

  execute(message: string, button: any) {
    this.notificationService.showErrorWithButton(message, button);
  }
}
